module.exports = __webpack_public_path__ + "img/img_supplier_kfdh@2x.94078aca.png";